/**
 * What the message log is being asked for.
 *
 * The page used to narrow the rows it already held: `rows.filter(direction)`
 * over the newest fifty. That answers "are there outbound messages among these
 * fifty" and the question asked is "are there outbound messages". With the
 * interesting ones older than the window, it answers no, and it is wrong.
 *
 * The correlation id matters more than any of the others and was not offered at
 * all. Finding the captured payload behind one refusal is what this page is for.
 */

import { asInstant, searchQuery } from './searchQuery'

export interface MessageFilters {
  direction?: string | null
  peer?: string
  correlationId?: string
  from?: string
  to?: string
}

export function toQuery(filters: MessageFilters, cursor?: string | null): string {
  return searchQuery(
    {
      direction: filters.direction,
      peer: filters.peer,
      correlation_id: filters.correlationId,
      from: asInstant(filters.from),
      to: asInstant(filters.to),
    },
    cursor,
  )
}
